import { Injectable, EventEmitter } from '@angular/core';
import { ChangeEvent } from '../events/ChangeEvent';


@Injectable({
  providedIn: 'root'
})
export class GlobalEventEmitterService {
  public static globalEmitter:EventEmitter<ChangeEvent> = new EventEmitter<ChangeEvent>();
  constructor() { }
}
